import _ from 'lodash';
import { CreditCard, BillbackCard, DeductionCard, DisputeCard, InvoiceCard, PaymentCard, PaginatedList, RepayCard } from 'components';
import { DataType } from 'enums';
import { useFilteredSearchResults, useSearchQuery } from 'state';
import { DisputeSummary, InvoiceSummary, PaymentSummary, PaymentDetail } from 'types';

export default function SearchItems() {
    const [query] = useSearchQuery();
    const searchResults = useFilteredSearchResults();
    
    if (query && _.isEmpty(searchResults)) {
        return <div>No results found for '{query}'</div>
    };
   
    return( 
        <PaginatedList
            componentKey='SearchPage'
            resetKey={query} 
            items={searchResults}
        >
            {item => {
                switch (item.type) {
                    case DataType.Dispute: {
                        const disputeData = item.data as DisputeSummary;
                        return <DisputeCard disputeSummary={disputeData} key={`dispute_${disputeData.disputeNumber}`} />;
                    }
                    case DataType.DotBillback: {
                        const paymentData = item.data as PaymentDetail;
                        return <BillbackCard payment={paymentData} key={`billback_${paymentData.invoiceId}`} />;
                    }
                    case DataType.Credit: {
                        const paymentData = item.data as PaymentDetail;
                        return <CreditCard payment={paymentData} key={`credit_${paymentData.invoiceId}`} />;
                    }
                    case DataType.Invoice: {
                        const invoiceData = item.data as InvoiceSummary;
                        return <InvoiceCard invoice={invoiceData} key={`invoice_${invoiceData.rowNumber}`} />;
                    }                     
                    case DataType.Payment: {
                        const paymentData = item.data as PaymentSummary;
                        return <PaymentCard paymentSummary={paymentData} key={`payment_${paymentData.paymentId}`} /> ;
                    }
                    case DataType.CustomerDeduction: {
                        const deductionData = item.data as PaymentDetail;
                        return <DeductionCard payment={deductionData} key={`payment_${deductionData.invoiceId}`} />;
                    }
                    case DataType.CustomerDedRepay: {
                        const repayData = item.data as PaymentDetail;
                        return <RepayCard payment={repayData} key={`repay_${repayData.invoiceId}`} />;
                    }
                }}
            }
        </PaginatedList>
    )
}